import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { userSignup } from "../utils/utils";
import AuthManager from "../authmanager/authmanager";
import karwan from "../images/karvaan.jpg";
import GoogleLoginButton from "../google/google";
import ErrorNotification from "../validators/errornotification";
// import { GoogleAuthorLoginButton } from "../google/google";

const Signup = ({ toggleTheme }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isAuthor, setIsAuthor] = useState(false); // Initialize as false
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const handleSignup = async () => {
    try {
      const response = await userSignup(username, password, isAuthor); // Pass `isAuthor` to the signup API
      const token = response.token;

      // Save the token in local storage
      localStorage.setItem("authToken", token);
      localStorage.setItem("author_or_not", isAuthor); // Store author status

      setSuccessMessage(response.data.message); // Assuming the API returns a message field
      navigate("/home");
    } catch (error) {
      if (error.response && error.response.request && error.response.request.response) {
        setError(error.response.request.response); // Accessing the error response
      } else {
        setError("An error occurred during signup.");
      }
    }
  };

  const handleCloseError = () => {
    setError(null); // Clear the error when the user closes the notification
  };

  const toggleAuthorSignup = () => {
    setIsAuthor((prev) => !prev); // Toggle the `isAuthor` state
  };

  return (
    <div>
      <GoogleLoginButton />
      
      <div>
        <img src={karwan} alt="Logo" className="logo" />
      </div>
      <hr className="horizontal-line" />
      <br />
      <br />
      <div className="heading-align">
        <h1 id="stylish">Create your Karvan account</h1>
        <div className="textbox-input">
          <div className="input-group-username">
            <label htmlFor="username">Email:</label>
            <input
              type="text"
              id="username"
              placeholder="Enter your email"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="input-group-password">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button className="btn-signup" onClick={handleSignup}>
            Signup
          </button>
        </div>

        {/* Toggle button to sign up as an author */}
        <div className="author-toggle">
          <label>
            <input
              type="checkbox"
              checked={isAuthor}
              onChange={toggleAuthorSignup}
            />
            Sign up as an Author
          </label>
        </div>

        {error && <ErrorNotification message={error} onClose={handleCloseError} />}
        {successMessage && <p>{successMessage}</p>}
        {/* Signup form content */}
        <div className="container">
          <div className="textbox">
            <p>Already have an account?</p>
            <div className="login-link">
              <Link
                to="/login"
                onClick={() => AuthManager.handleLogin(username, password)}
              >
                Login here
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
